export const routes = [
  { path: "/", nameKey: "nav.home" },
  { path: "/portfolio", nameKey: "nav.portfolio" },
  { path: "/contact", nameKey: "nav.contact" },
];
